/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobLog {
    getFixupPrototypeFunction() { return BackgroundJobLog.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobLog>): BackgroundJobLog {
        let obj = Object.assign(new BackgroundJobLog(), model);
        BackgroundJobLog.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobLog>): BackgroundJobLog {
        if (!model) return null;
        return BackgroundJobLog.newInstance(<BackgroundJobLog> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobLog) {
        if (!obj) return;

        models.BackgroundJobLog.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobLog): boolean {
        Object.setPrototypeOf(obj, BackgroundJobLog.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.timestamp === "string") {
            this.timestamp = new Date(<string><any>this.timestamp);
        }
    }

    /**
     * When the log entry was created
     */
    timestamp: Date;

    /**
     * Name of the logger
     */
    logger: string;

    /**
     * Level of the log entry
     */
    logger_level: string;

    /**
     * Where the log entry was generated
     */
    code_context: string;

    /**
     * Content of the log
     */
    message: string;

}
